<app-layout>
  <app-voltar route="listagem/estoque" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>Entrada de Estoque</app-titulo>
    </div>
  </div>
  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input type="select" label="Produto" name="FK_PROD" formControlName="FK_PROD"
          [selectData]="produtoOptions" [requiredInput]="true" (ngModelChange)="onSelectChange($event, 'FK_PROD')">
        </app-input>
        <app-input type="number" label="Quantidade" name="QT_MOVM" formControlName="QT_MOVM" [requiredInput]="true">
        </app-input>
        <app-input label="Observação" name="TX_OBSV" formControlName="TX_OBSV" maxLength="500"></app-input>
      </div>
      <app-botao type="cadastro" class="botao-cadastro" text="Registrar Entrada" (click)="postarDados()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
